
    import Vue from 'vue'
    import { UserService } from '@/services/UserService'
    import UserInfo from '@/models/api/user/UserInfo';
    import { AspNetRole, AssociationRoleEnum } from '@/models/Enums';
    import { UserHelper } from '@/helpers/UserHelper';
    import SelectListItem from '@/models/SelectListItem';
    import AssociationUserInfo from '../../models/api/user/AssociationUserInfo';
    import { GenericService } from '../../services/GenericService';
    import { mapGetters } from 'vuex';
import { SnackbarService } from '../../services/SnackbarService';
import { SettingService } from '../../services/SettingService';

    interface Data {
        errors: [""];
        email: string;
        password: string;
        showPassword: boolean;
        role: AspNetRole;
        apiToken: null | string;
        rules: boolean | string;
    }

    export default Vue.extend({
      data() {
        return {
            showSelectAssociationUser: false,
            associationUserIds: [new SelectListItem("", "")],
            selectedAssociationUserId: "",

            showResetPassword: false,
            resetPasswordEmail: "",

            loading: false,
            post: null,
            email: "",
            password: "",
            showPassword: false,
            apiToken: "",
            rules: {
                required: (value: any) => !!value || 'Obligatoriskt.',
                email: (value: any) => !value
                    || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
                    || this.$vuetify.lang.t('$vuetify.invalidEmail'),
            },

            accessibilityStatementUrl: "",
            databaseVersion: "",
            welcomeTextWithMunicipalityName: "",
            imageLogoFile: null,
        }
      },
      created() {
        //const userInfo = SessionHelper.getUserInfo();
          const userInfo = this.$store.state.userInfo;

        if (userInfo && userInfo.token) {
          this.apiToken = userInfo.token;
        }

          /*
          setTimeout(() => {
              SnackbarService.addSuccessMessage("Något bra har hänt. Automatisk stängning efter standardtiden på 4 sekunder!");
              //SnackbarService.addSuccessMessage("Något bra har hänt. Automatisk stängning efter den specificerade tiden på 5 sekunder!", 5000);
              //SnackbarService.addSuccessMessage("Något bra har hänt. Inte manuell stängning efter standardtiden på 4 sekunder!", false);
              SnackbarService.addSuccessMessage("Något bra har hänt. Manuell stängning!", true);
              SnackbarService.addWarningMessage("Något har hänt. Automatisk stängning efter standardtiden på 7 sekunder!");
              //SnackbarService.addWarningMessage("Något har hänt. Automatisk stängning efter den specificerade tiden på 5 sekunder!", 5000);
              //SnackbarService.addWarningMessage("Något har hänt. Inte manuell stängning efter standardtiden på 4 sekunder!", false);
              SnackbarService.addWarningMessage("Något har hänt. Manuell stängning!", true);
              SnackbarService.addErrorMessage("Något obra har hänt. Manuell stängning!");
          }, 2000);
          */


          SettingService.GetDatabaseVersion().then((response) => {
              //console.log(response);
              this.databaseVersion = response.data;
              //console.log(this.accessibilityStatementUrl);
          })
          .catch((error) => {
            if (error.response.data.errors) {
                SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
            } else {
                SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
            }
          })
          .finally(() => {
          });

          SettingService.GetAccessibilityStatementUrl().then((response) => {
              //console.log(response);
              this.accessibilityStatementUrl = response.data;
              //console.log(this.accessibilityStatementUrl);
          })
              .catch((error) => {
                  if (error.response.data.errors) {
                      SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
                  } else {
                      SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                  }
              })
              .finally(() => {
              });


      
          this.getMunicipalityNameWithLoginPageText()
          this.getMunicipalityLogo();

      },
        methods: {


            getMunicipalityNameWithLoginPageText() {

                 SettingService.GetMunicipalityNameWithLoginPageText().then((response) => {
                    this.welcomeTextWithMunicipalityName =  response.data;
                  
                }).catch((error) => {
                        if (error.response.data.errors) {
                            SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
                        } else {                           
                            SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                        }
                    })
                    .finally(() => {
                    });
            },

            getMunicipalityLogo() {

                 SettingService.GetMunicipalityLogo().then(response => {
                    this.imageLogoFile = response.data!;
                }).catch((error) => {
                    if (error.response.data.errors) {
                        SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
                    } else {                        
                        SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                    }
                }).finally(() => {
                });
            },


        resetPassword(): void {
            //this.showSaved = false;

            window.location.href.lastIndexOf("#/")
            const validateEmailUrl = window.location.href.substr(0, window.location.href.lastIndexOf("#") + 1) + "/confirmUser";

            this.$store.commit('addOverlay');

            UserService.SendResetPassword({ email: this.resetPasswordEmail, emailConfirmationUrl: validateEmailUrl }).finally(() => {
                this.$store.commit('removeOverlay');
                SnackbarService.addSuccessMessage(this.$vuetify.lang.t('$vuetify.user.resetPasswordSent'));
                this.resetPasswordEmail = "";
                this.showResetPassword = false;
            });
        },
        logout(): void {
          UserHelper.logoff(this);
        },

        /*
         * ALMOST SAME CODE AS SELECT ASSOCIATION USER IN App.vue! Changes might need to be done there too!
         */
        setValuesFromAuthenticationResponse(response: any) {
            let userInfo = new UserInfo();
            userInfo.aspNetRole = response.data.role;
            userInfo.name = response.data.name;
            userInfo.isAuthenticated = true;
            userInfo.token = response.data.token as string;
            userInfo.hasMultipleAssociationUsers = response.data.hasMultipleAssociationUsers;

            if (response.data.associationUserInfo) {
                userInfo.associationUserInfo = new AssociationUserInfo();
                userInfo.associationUserInfo.id = response.data.associationUserInfo.id;
                userInfo.associationUserInfo.role = response.data.associationUserInfo.role;
                userInfo.associationUserInfo.name = response.data.associationUserInfo.name;
                userInfo.associationUserInfo.associationName = response.data.associationUserInfo.associationName;
            } else {
                userInfo.associationUserInfo = null;
            }

            return userInfo;
        },
        /*
         * ALMOST SAME CODE AS SELECT ASSOCIATION USER IN App.vue! Changes might need to be done there too!
         */
        handleAuthentication(userInfo: UserInfo) {

          //SessionHelper.sessionSetItem("UserInfo", userInfo);
          this.$store.commit("setUserInfo", userInfo);

          //console.log(userInfo);
          
          switch (userInfo.aspNetRole) {
            case AspNetRole.SystemAdmin:
              console.log("no page defined", AspNetRole.SystemAdmin.toString());
              break;
              case AspNetRole.MunicipalityAdmin:
              console.log("no page defined", AspNetRole.MunicipalityAdmin.toString());
             //   console.log("User is ", AspNetRole.MunicipalityAdmin.toString(), "redirecting" );
              //this.$router.push("/municipality");
              //return;
              break;
            case AspNetRole.AssociationUser:
              if (userInfo.associationUserInfo?.role == AssociationRoleEnum.AssociationAdmin) {
                  this.$router.push("/association");
                
              } else {                 
                  this.$router.push("/association/occasions");
              }
              break;
            default:
              console.log("unhandled for user role", userInfo.aspNetRole);
              break;
            }

            //this.testAuthorization();
        },
        /*
         * ALMOST SAME CODE AS SELECT ASSOCIATION USER IN App.vue! Changes might need to be done there too!
         */
        async setAssociationUser() {
          this.$store.commit("addOverlay");
          UserService.SetAssociationUser(
            { id: parseInt(this.selectedAssociationUserId) },
            this.apiToken
          )
            .then((response) => {
              const userInfo = this.setValuesFromAuthenticationResponse(response);
              this.handleAuthentication(userInfo);

              this.showSelectAssociationUser = false;
            })
            .catch((error) => {
              if (error.response.data.errors) {
                  SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
              } else {
                  SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
              }
            })
            .finally(() => {
              this.$store.commit("removeOverlay");
            });
        },
        async submit() {

          this.$store.commit("addOverlay");
          UserService.Login({ email: this.email, password: this.password })
            .then((response) => {

              const userInfo = this.setValuesFromAuthenticationResponse(response);

              if (
                userInfo.aspNetRole == AspNetRole.AssociationUser &&
                !userInfo.associationUserInfo
              ) {
                // We do not set the token for calls as this token does not contain the association role
                // We need to select role and get new token

                // Temporary stores api token for setAssociationUser call
                this.apiToken = response.data.token;

                this.$store.commit("addOverlay");
                UserService.GetAssociationUsers(userInfo.token)
                  .then((response) => {
                    this.associationUserIds = response.data.items;
                    this.showSelectAssociationUser = true;
                  })
                  .catch((error) => {
                      if (error.response.data.errors) {
                          SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
                      } else {
                          SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                      }
                  })
                  .finally(() => {
                    this.$store.commit("removeOverlay");
                  });

                return;
              }

                this.handleAuthentication(userInfo);

                }).catch((error) => {
                    if (error.response.data.errors) {
                        SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
                    } else {
                        SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                    }
                }).finally(() => {
                    this.$store.commit('removeOverlay');
                });
        },



            testAuthorization(): void {
                GenericService.Get('user', 'testSystemAdmin')
                    .then(response => {
                        console.log('testSystemAdmin : ' + response.data);
                        return;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                GenericService.Get('user', 'testMunicipalityAdmin')
                    .then(response => {
                        console.log('testMunicipalityAdmin : ' + response.data);
                        return;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                GenericService.Get('user', 'testSystemAndMunicipalityAdmin')
                    .then(response => {
                        console.log('testSystemAndMunicipalityAdmin : ' + response.data);
                        return;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                GenericService.Get('user', 'testAssociationUser')
                    .then(response => {
                        console.log('testAssociationUser : ' + response.data);
                        return;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                GenericService.Get('user', 'testAssociationUser_Admin')
                    .then(response => {
                        console.log('testAssociationUser_Admin : ' + response.data);
                        return;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                GenericService.Get('user', 'testAssociationUser_User')
                    .then(response => {
                        console.log('testAssociationUser_User : ' + response.data);
                        return;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                GenericService.Get('user', 'testAllAdmin')
                    .then(response => {
                        console.log('testAllAdmin : ' + response.data);
                        return;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },

        },
        computed: {
            appVersion(): any {
                return process.env.PACKAGE_VERSION || '0';
            },
            buildDate(): any {
                console.log(process.env);
                return process.env.VUE_APP_BUILD_DATE || '0';
            },
            ...mapGetters(["isAuthenticated",
                "isSystemAdmin",
                "isMunicipalityAdmin",
                "isAssociationUser_Admin",
                "isAssociationUser_GroupAdmin"
            ])

        },
    });
